/*
 JS Specific for the Diet sub page
 */

var viewportWidth = function(){
	var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	return width;
}
diet = {
	init: function initialize(){
		this.cE();
		if(document.body.style.MozTransform !== undefined){
			// THIS IS FIREFOX
			// Firefox doesn't support percentages with svg and `transform-origin`. If you are reading this, please check it's status with Firefox, because the animations work there, but they work wrong due to each elements origin. The svgs are resized, so finding px positions is a pain
		} else {
			// fire webanimations, but not on Firefox
			this.wA();
		}
	},
	cE: function cacheElements(){
		/*
		 * If page is less than or equal to 600px AND supports touchevents, then cache it's state via diet.VPM
		 */
		diet.VPM = false; // viewport mobile
		if(viewportWidth() <= 600 && Modernizr.touchevents){
			diet.VPM = true;
		}
		
		/*
		 * DIET
		 */

		diet.boilingSvg = {};
		diet.boilingSvg.el = document.querySelector("svg.boiling");
		diet.boilingSvg.lid = diet.boilingSvg.el.querySelector(".lid");
		diet.boilingSvg.bubble1 = diet.boilingSvg.el.querySelector(".bubble-1");
		diet.boilingSvg.bubble2 = diet.boilingSvg.el.querySelector(".bubble-2");
		diet.boilingSvg.bubble3 = diet.boilingSvg.el.querySelector(".bubble-3");
		diet.boilingSvg.bubble4 = diet.boilingSvg.el.querySelector(".bubble-4");
		diet.boilingSvg.flame1 = diet.boilingSvg.el.querySelector(".flame-left");
		diet.boilingSvg.flame2 = diet.boilingSvg.el.querySelector(".flame-center");
		diet.boilingSvg.flame3 = diet.boilingSvg.el.querySelector(".flame-right");
		
	},

	wA: function webAnimations() {
		
		diet.boilingSvg.lidAnimation = diet.boilingSvg.lid.animate([
			{transform: "translate(0px,0px) rotate(0deg)"},
			{transform: "translate(-1px,-1px) rotate(-1deg)"},
			{transform: "translate(0px,0px) rotate(0deg)"},
			{transform: "translate(1px,-1px) rotate(1deg)"}
		], {
			direction: 'alternate',
			duration: 500,
			iterations: Infinity
		});
		diet.boilingSvg.bubble1Animation = diet.boilingSvg.bubble1.animate([
			{transform: "translate(0px,45px)", opacity: 0},
			{transform: "translate(-2px,40px)", opacity: 1},
			{transform: "translate(2px,5px)", opacity: 1},
			{transform: "translate(0px,0px)", opacity: 0},
		], {
			direction: 'normal',
			duration: 1000,
			iterations: Infinity
		});
		diet.boilingSvg.bubble2Animation = diet.boilingSvg.bubble2.animate([
			{transform: "translate(0px,33px)", opacity: 0},
			{transform: "translate(2px,28px)", opacity: 1},
			{transform: "translate(-2px,-5px)", opacity: 1},
			{transform: "translate(0px,-10px)", opacity: 0},
		], {
			direction: 'normal',
			duration: 1000,
			iterations: Infinity,
			delay: 250
		});
		diet.boilingSvg.bubble3Animation = diet.boilingSvg.bubble3.animate([
			{transform: "translate(0px,26px)", opacity: 0},
			{transform: "translate(3px,21px)", opacity: 1},
			{transform: "translate(-3px,-19px)", opacity: 1},
			{transform: "translate(0px,-24px)", opacity: 0},
		], {
			direction: 'normal',
			duration: 1000,
			iterations: Infinity,
			delay: 500
		});
		diet.boilingSvg.bubble4Animation = diet.boilingSvg.bubble4.animate([
			{transform: "translate(0px,13px)", opacity: 0},
			{transform: "translate(-5px,40px)", opacity: 1},
			{transform: "translate(1px,-29px)", opacity: 1},
			{transform: "translate(0px,-34px)", opacity: 0},
		], {
			direction: 'normal',
			duration: 1000,
			iterations: Infinity,
			delay: 750
		});
		diet.boilingSvg.flame1Animation = diet.boilingSvg.flame1.animate([
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(-5deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
		], {
			direction: 'alternate',
			duration: 5000,
			iterations: Infinity
		});
		diet.boilingSvg.flame2Animation = diet.boilingSvg.flame2.animate([
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(-5deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
		], {
			direction: 'alternate',
			duration: 3333,
			iterations: Infinity,
			delay: 500
		});
		diet.boilingSvg.flame3Animation = diet.boilingSvg.flame3.animate([
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
			{transform: "translate(0px,0px) scale(0.9) rotate(-5deg)"},
			{transform: "translate(0px,0px) scale(1) rotate(0deg)"},
		], {
			direction: 'alternate',
			duration: 2500,
			iterations: Infinity,
			delay: 250
		});
		
	},

} // end diet
